module.exports = __webpack_public_path__ + "static/media/Reviews Google.3ae25624.png";